import type { FC } from 'react';
import { DetailList } from '../DetailList';
import { SectionText } from '../Section';
import * as Styled from './styled';
import type { BreedOverviewProps } from './types';

export * from './types';

export const BreedOverview: FC<BreedOverviewProps> = (props) => {
  const { count, description, title, image, details, subscribeBtn } = props;

  return (
    <>
      <Styled.Wrapper>
        <Styled.Image>
          <img src={image} alt={title} />
        </Styled.Image>

        <Styled.Content>
          <Styled.TitleSubscribeWrapper>
            <Styled.Title>{title}</Styled.Title>
            {subscribeBtn}
          </Styled.TitleSubscribeWrapper>

          {count && <Styled.Count>{count}</Styled.Count>}
          <SectionText>{description}</SectionText>

          {/* Not the same design as Card :( */}
          <Styled.DetailsCard>
            <DetailList items={details ?? []} />
          </Styled.DetailsCard>
        </Styled.Content>
      </Styled.Wrapper>
    </>
  );
};
